import { ProductType } from "../../core/products"

import * as Yup from 'yup'

export interface BaseResponseModel {
  success: boolean
  message: string
}

export interface WebLoginResponseModel { 
  loggedIn: boolean
  resetpassword: boolean
  id: number
  email: string
  name: string
  role: string    
  message:string
}

export interface AuthModel {
  id: number    
  email: string
  name?: string
  role?: string
  password: string
  loggedIn: boolean    
  isSetsco?: boolean
  requireReview?: boolean
}

export interface UserAddressModel {
  addressLine: string
  city: string
  state: string
  postCode: string
}

export interface UserCommunicationModel {
  email: boolean
  sms: boolean
  phone: boolean
}

export interface UserEmailSettingsModel {
  emailNotification?: boolean
  sendCopyToPersonalEmail?: boolean
  activityRelatesEmail?: {
    youHaveNewNotifications?: boolean
    youAreSentADirectMessage?: boolean
    someoneAddsYouAsAsAConnection?: boolean
    uponNewOrder?: boolean
    newMembershipApproval?: boolean
    memberRegistration?: boolean
  }
  updatesFromKeenthemes?: {
    newsAboutKeenthemesProductsAndFeatureUpdates?: boolean
    tipsOnGettingMoreOutOfKeen?: boolean
    thingsYouMissedSindeYouLastLoggedIntoKeen?: boolean
    newsAboutStartOnPartnerProductsAndOtherServices?: boolean
    tipsOnStartBusinessProducts?: boolean
  }
}

export interface UserSocialNetworksModel {
  linkedIn: string
  facebook: string
  twitter: string
  instagram: string
}

export interface CompanyModel {
  id?: number
  name: string
  uen: string
  address: string
  website: string
  tel: string
  fax: string
  deleted?: boolean
  dteCr?: string
  dteUpd?: string    
}


export interface UserModel {
  id: number    
  email: string
  password?: string

  name: string
  role: string
  lastLoginDate? : string

  deleted?: boolean
  dteCr?: string
  dteUpd?: string
  
  wrongPwdCount?: number
  
  locked?: boolean 
  
  company? : CompanyModel        
  designation? : string

  isSetsco? : boolean
  requireReview? : boolean

  loggedIn?: boolean
  message? : string
  productTypes? : Array<ProductType>
  companies? : Array<CompanyModel>
}




export interface OnBoardingModel {
  id?: number
  companyName: string
  uen: string
  address: string
  website: string
  tel: string
  fax: string
  applicantName: string    
  email: string
  password: string
  designation: string
  role?: string
  otp?: string
  otpDate?: string
  created?: string
  deleted?: boolean
  dteCr?: string
  dteUpd?: string
}

export const AuthPasswordValidationSchema = Yup
  .string()
  .min(8, 'Password too short')
  .test(
  'isValidPass',
  'Must be a mix of letters, numbers & symbols.',
  (value: any, context: any) => {
    // skip empty values
    if (! (value && value.length > 0)) return true;
    
    const hasUpperCase = /[A-Z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasSymbol = /["!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"]/.test(value);
    let validConditions = 0;
    const numberOfMustBeValidConditions = 3;
    const conditions = [hasUpperCase, hasLowerCase, hasNumber, hasSymbol];
    conditions.forEach(condition => (condition ? validConditions++ : null));
    if (validConditions >= numberOfMustBeValidConditions) {
      return true;
    }
    return false;
  }
)